import Chip from '@mui/material/Chip';
import type { AcceptanceStatus } from '../types';
import { ACCEPTANCE_STATUS_META } from '../theme';

interface StatusBadgeProps {
  status: AcceptanceStatus;
  size?: 'small' | 'medium';
  testId?: string;
}

/**
 * Chip trạng thái nghiệm thu — bao phủ 4 tình huống hiển thị:
 *  - PENDING (Chờ nghiệm thu) — xám trung tính
 *  - CONFIRMED (Đã xác nhận) — xanh lá
 *  - CHANGE_REQUESTED (Yêu cầu thay đổi) — cảnh báo (cam)
 *  - "Đã xử lý" (biến thể nhấn khi yêu cầu thay đổi đã được resolve)
 */
export function StatusBadge({ status, size = 'small', testId }: StatusBadgeProps): JSX.Element {
  const meta = ACCEPTANCE_STATUS_META[status];
  return (
    <Chip
      label={meta.label}
      color={meta.color === 'default' ? 'default' : meta.color}
      size={size}
      variant={meta.color === 'default' ? 'outlined' : 'filled'}
      sx={{ fontWeight: 600 }}
      data-testid={testId}
    />
  );
}
